export type OrigemItemOrcamento = 'produto' | 'carregador' | 'avulso';

export interface GrupoDespesaOrcamento {
  id: string;
  nome: string;
}

export interface ItemOrcamentoCarregador {
  id: string;
  origem: OrigemItemOrcamento;
  produto_id: string | null;
  modelo_carregador_id: string | null;
  grupo_id: string | null;
  codigo: string;
  descricao: string;
  unidade: string;
  quantidade: number;
  valor_unitario: number;
  incluir_no_pdf?: boolean;
}

export interface OrcamentoCarregadorResumo {
  id: string;
  nome_projeto: string;
  cliente: string | null;
  local_obra: string | null;
  valor_total: number;
  qtd_itens: number;
  updated_at: string;
  created_at: string;
}

export interface OrcamentoCarregador extends OrcamentoCarregadorResumo {
  observacoes: string | null;
  grupos: GrupoDespesaOrcamento[];
  itens: ItemOrcamentoCarregador[];
}

export interface ProdutoOrcamento {
  id: string;
  codigo: string;
  descricao: string;
  unidade: string;
  preco_venda: number;
  preco_custo: number;
  ativo: boolean;
}

export interface ModeloOrcamento {
  id: string;
  marca: string;
  modelo: string;
  codigo: string | null;
  potencia_nominal_kw: number;
  tipo_corrente: string;
}

export interface CatalogoOrcamento {
  produtos: ProdutoOrcamento[];
  modelos: ModeloOrcamento[];
}

export function totalItemOrcamento(item: Pick<ItemOrcamentoCarregador, 'quantidade' | 'valor_unitario'>): number {
  const bruto = (Number(item.quantidade) || 0) * (Number(item.valor_unitario) || 0);
  return Math.round(bruto * 100) / 100;
}

export function totalOrcamento(itens: ItemOrcamentoCarregador[]): number {
  const soma = itens.reduce((acumulado, item) => acumulado + totalItemOrcamento(item), 0);
  return Math.round(soma * 100) / 100;
}

export function totalGrupoOrcamento(itens: ItemOrcamentoCarregador[], grupoId: string): number {
  return totalOrcamento(itens.filter((item) => item.grupo_id === grupoId));
}

export function rotuloOrigemItem(origem: OrigemItemOrcamento): string {
  switch (origem) {
    case 'produto':
      return 'Produto';
    case 'carregador':
      return 'Carregador';
    case 'avulso':
      return 'Avulso';
    default: {
      const nunca: never = origem;
      return nunca;
    }
  }
}
